(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTORS = [
    '.adam-cards__header', '.adam-cards__card',
    '.adam-gallery__header', '.adam-gallery__item',
    '.adam-services__header', '.adam-services__card',
    '.adam-cta__box',
    '.adam-contact__header', '.adam-contact__card', '.adam-contact__map', '.adam-contact__form-wrap',
    '.adam-social__header', '.adam-social__link'
  ].join(',');

  const groups = new Map();

  function prepare(el) {
    if (el.dataset.adamsRevealReady) return;
    el.dataset.adamsRevealReady = '1';
    el.classList.add('adams-reveal');
    const parent = el.parentElement;
    const index = groups.get(parent) || 0;
    groups.set(parent, index + 1);
    const delay = Math.min(index, 5) * 90;
    el.style.setProperty('--reveal-delay', delay + 'ms');
  }

  function scan() {
    document.querySelectorAll(SELECTORS).forEach(prepare);
  }

  scan();

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.adams-reveal').forEach((el) => io.observe(el));

  new MutationObserver(() => {
    scan();
    document.querySelectorAll('.adams-reveal:not(.is-visible)').forEach((el) => io.observe(el));
  }).observe(document.body, { childList: true, subtree: true });
})();
